import { riskManagementResourceAdapter } from './RiskManagement.resource';
export function LpvResourceAdapter(data) {
    var _data$firstAccount, _data$firstAccount2, _data$firstAccount3, _data$pair, _data$pair2, _data$pair3, _data$firstAccount4, _data$firstAccount5, _data$firstAccount6, _data$firstAccount7, _data$firstAccount8, _data$firstAccount9, _data$secondAccount, _data$secondAccount2, _data$secondAccount3, _data$secondAccount4, _data$secondAccount5, _data$secondAccount6, _data$pair4, _data$pair5, _data$pair6, _data$pair7, _data$pair8;
    var accountBroker = {
        id: (_data$firstAccount = data.firstAccount) === null || _data$firstAccount === void 0 ? void 0 : _data$firstAccount.broker.id,
        name: (_data$firstAccount2 = data.firstAccount) === null || _data$firstAccount2 === void 0 ? void 0 : _data$firstAccount2.broker.name,
        separator: (_data$firstAccount3 = data.firstAccount) === null || _data$firstAccount3 === void 0 ? void 0 : _data$firstAccount3.broker.separator,
        hasUniqueTradeId: data.firstAccount.broker.hasUniqueTradeId
    };
    var pairBroker = {
        id: (_data$pair = data.pair) === null || _data$pair === void 0 ? void 0 : _data$pair.broker.id,
        name: (_data$pair2 = data.pair) === null || _data$pair2 === void 0 ? void 0 : _data$pair2.broker.name,
        separator: (_data$pair3 = data.pair) === null || _data$pair3 === void 0 ? void 0 : _data$pair3.broker.separator,
        hasUniqueTradeId: data.firstAccount.broker.hasUniqueTradeId
    };
    var firstAccount = {
        id: (_data$firstAccount4 = data.firstAccount) === null || _data$firstAccount4 === void 0 ? void 0 : _data$firstAccount4.id,
        name: (_data$firstAccount5 = data.firstAccount) === null || _data$firstAccount5 === void 0 ? void 0 : _data$firstAccount5.name,
        key: (_data$firstAccount6 = data.firstAccount) === null || _data$firstAccount6 === void 0 ? void 0 : _data$firstAccount6.key,
        secret: (_data$firstAccount7 = data.firstAccount) === null || _data$firstAccount7 === void 0 ? void 0 : _data$firstAccount7.secret,
        passphrase: (_data$firstAccount8 = data.firstAccount) === null || _data$firstAccount8 === void 0 ? void 0 : _data$firstAccount8.passphrase,
        broker: accountBroker,
        pair: (_data$firstAccount9 = data.firstAccount) === null || _data$firstAccount9 === void 0 ? void 0 : _data$firstAccount9.pair,
        type: data.firstAccount.type,
        mainAccount: data.firstAccount.mainAccount,
        main: data.firstAccount.main,
        client: data.firstAccount.client
    };
    var secondAccount = {
        id: (_data$secondAccount = data.secondAccount) === null || _data$secondAccount === void 0 ? void 0 : _data$secondAccount.id,
        name: (_data$secondAccount2 = data.secondAccount) === null || _data$secondAccount2 === void 0 ? void 0 : _data$secondAccount2.name,
        key: (_data$secondAccount3 = data.secondAccount) === null || _data$secondAccount3 === void 0 ? void 0 : _data$secondAccount3.key,
        secret: (_data$secondAccount4 = data.secondAccount) === null || _data$secondAccount4 === void 0 ? void 0 : _data$secondAccount4.secret,
        passphrase: (_data$secondAccount5 = data.secondAccount) === null || _data$secondAccount5 === void 0 ? void 0 : _data$secondAccount5.passphrase,
        broker: accountBroker,
        pair: (_data$secondAccount6 = data.secondAccount) === null || _data$secondAccount6 === void 0 ? void 0 : _data$secondAccount6.pair,
        type: data.secondAccount.type,
        mainAccount: data.secondAccount.mainAccount,
        main: data.secondAccount.main,
        client: data.secondAccount.client
    };
    var pair = {
        id: (_data$pair4 = data.pair) === null || _data$pair4 === void 0 ? void 0 : _data$pair4.id,
        name: (_data$pair5 = data.pair) === null || _data$pair5 === void 0 ? void 0 : _data$pair5.name,
        baseCurrency: (_data$pair6 = data.pair) === null || _data$pair6 === void 0 ? void 0 : _data$pair6.baseCurrency,
        quoteCurrency: (_data$pair7 = data.pair) === null || _data$pair7 === void 0 ? void 0 : _data$pair7.quoteCurrency,
        maxSum: (_data$pair8 = data.pair) === null || _data$pair8 === void 0 ? void 0 : _data$pair8.maxSum,
        broker: pairBroker,
        restartMaxTimeValue: data.pair.restartMaxTimeValue,
        minQuantity: data.pair.minQuantity
    };
    var riskManagement = riskManagementResourceAdapter(data.riskManagement);
    return {
        id: data === null || data === void 0 ? void 0 : data.id,
        firstAccount: firstAccount,
        secondAccount: secondAccount,
        pair: pair,
        active: data === null || data === void 0 ? void 0 : data.active,
        state: data.state,
        createdAt: data === null || data === void 0 ? void 0 : data.createdAt,
        buyPercentage: data === null || data === void 0 ? void 0 : data.buyPercentage,
        sellPercentage: data === null || data === void 0 ? void 0 : data.sellPercentage,
        duration: data === null || data === void 0 ? void 0 : data.duration,
        intervalType: data === null || data === void 0 ? void 0 : data.intervalType,
        interval: data === null || data === void 0 ? void 0 : data.interval,
        sumStepType: data === null || data === void 0 ? void 0 : data.sumStepType,
        sumBid: data === null || data === void 0 ? void 0 : data.sumBid,
        sumAsc: data === null || data === void 0 ? void 0 : data.sumAsc,
        statuses: data.statuses,
        multiplier: data.multiplier,
        maxMultiplier: data.maxMultiplier,
        minVolume: data.minVolume,
        maxVolume: data.maxVolume,
        volumeInterval: data.volumeInterval,
        maxMultiplierDuration: data.maxMultiplierDuration,
        minInterval: data.minInterval,
        maxSum: data.maxSum,
        minSum: data.minSum,
        priceStepType: data.priceStepType,
        priceValue: data.priceValue,
        countOrderAsc: data.countOrderAsc,
        countOrderBid: data.countOrderBid,
        hedging: data.hedging,
        riskManagement: riskManagement
    };
}
